<template>
   <el-form ref="formRef" :model="form" label-width="100px" :label-position="getIsMobile?'top':'right'" >
     <el-form-item label="纳税识别号" prop="kpsbnum">
        <el-input type="text" placeholder="请输入纳税识别号" v-model="form.kpsbnum"/>
     </el-form-item>
     <el-form-item label="公司地址" prop="kpaddress">
       <el-input type="text" placeholder="请输入公司地址" v-model="form.kpaddress"/>
     </el-form-item>
     <el-form-item label="公司电话" prop="tel">
       <el-input type="text" placeholder="请输入公司电话" v-model.number="form.tel"/>
     </el-form-item>
     <el-form-item label="传真" prop="max">
       <el-input type="text" placeholder="请输入传真号" v-model.number="form.max"/>
     </el-form-item>
     <el-form-item label="开户银行" prop="bank">
       <el-input type="text" placeholder="请输入开户银行" v-model.number="form.bank"/>
     </el-form-item>
     <el-form-item label="银行账号" prop="banknum">
       <el-input type="text" placeholder="请输入银行账号" v-model.number="form.banknum"/>
     </el-form-item>
     <el-form-item label="备注" prop="kpbz">
       <el-input type="text" placeholder="请输入备注" v-model="form.kpbz"/>
     </el-form-item>
   </el-form>
</template>
<script>
import { defineComponent, reactive,ref,watch } from '@vue/composition-api'
import useRootSetting from '@/hooks/useRootSetting'
export default defineComponent({
  components: {},
  props: {
    data: {
      type: Array,
      default: ()=> {return []}
    }
  },
  setup(props,{ emit }) {
    const {getIsMobile} = useRootSetting()
    const formRef = ref(null)
    const defaultForm = () => ({
      kpsbnum:'',
      kpaddress:'',
      tel:'',
      max:'',
      bank:'',
      banknum:'',
      kpbz:''
    })
    const form = reactive(defaultForm())

    const handleReset = () => Object.assign(form,defaultForm())

    watch(() => props.data, (val) => {
      if (val) {
        // 更新 form 中已有的字段
        Object.keys(form).forEach(key => {
          if (key in val[0]) {
            form[key] = val[0][key];  // 只更新 form 中已存在的字段
          }
        });
      }
    });

    return {
      getIsMobile,
      formRef,
      form,
      handleReset
    }
  }
})
</script>
